/** One clock for the title, guide, paired windows and their actual actions. */
export const WORKFLOW_SCORE = Object.freeze({
  firstDuration: 10700, turnDuration: 8450, duration: 36050,
  extensionApproachDuration: 1000, extensionSetupDelay: 500,
  readStart: 1000, readEnd: 3100, restEnd: 3900,
  windowsStart: 3900, actionsStart: 4500, nextActionsStart: 1250,
});
const ease = (value: number): number => {
  const t = Math.max(0, Math.min(1, value));
  return t*t*t*(t*(t*6-15)+10);
};
export function sampleWorkflow(elapsed: number) {
  const s=WORKFLOW_SCORE;
  const index=elapsed<s.firstDuration?0:Math.min(3,1+Math.floor((elapsed-s.firstDuration)/s.turnDuration));
  const local=Math.max(0,elapsed-(index===0?0:s.firstDuration+(index-1)*s.turnDuration));
  const reveal=ease((local-(index===0?0:400))/(index===0?1000:850));
  return {index,local,reveal,previous: index>0?1-ease(local/400):0,
    proofElapsed:local-(index===0?s.actionsStart:s.nextActionsStart),
    windows:index>0?1:ease((local-s.windowsStart)/(s.actionsStart-s.windowsStart))};
}
